export const API = {
    VERIFY_CUSTOMER_OTP: 'v1/Customer/VerifyCustomerOtp',
}